export enum ProductItemTypes {
   RAFFLE = 'raffle',
   POINTS_EXCHANGE = 'points-exchange',
}

export enum ProductItemStatuses {
   ALL = 'all',
   ACTIVE = 'active',
   COMING = 'coming',
   ENDED = 'ended',
}
